import { Editor } from "@tinymce/tinymce-react";

const initializeTinyMCE = () => {
	if (!process.env.REACT_APP_TINY_MCE) {
		throw new Error("Mandatory tiny mce env variable missing!");
	}
	const existingScript = document.getElementById("tinymceinitialization");
	if (!existingScript) {
		const script: HTMLScriptElement = document.createElement("script");
		script.src = "https://tinymce.zomentum.com/tinymce.min.js";
		script.referrerPolicy = "origin";
		script.id = "tinymceinitialization";
		document.head.appendChild(script);
	}
};

export { Editor };
export default initializeTinyMCE;
